import Head from "next/head";
import { PageIndex } from "../components/pages/PageIndex";
import { useRouter } from "next/router";
import { useEffect } from "react";
import useGameStore from "../lib/store/GameStore";
import {
  gridLevelDateKey,
  gridLevelNumber,
  getDateKeyForLevel,
} from "../lib/utils/gridLevels";
import { dateToKey } from "../lib/utils/dateFunctions";

const PAGE_TITLE = "Past Games | BikeGrid";

export default function SSG() {
  const [user, isUserLoading, isOpen, setIsOpen] = useGameStore((state) => [
    state.user,
    state.isUserLoading,
    state.isRegisterOpen,
    state.setIsRegisterOpen,
  ]);

  const router = useRouter();
  const { date } = router.query;

  useEffect(() => {
    // 'date' contains the parameter value
    // console.log("Date Parameter:", date);

    // Redirect to current date
    if (
      date &&
      (date > dateToKey(new Date()) ||
        date <= getDateKeyForLevel(gridLevelNumber - 7))
    ) {
      const newUrl = `/`;

      window.location.href = newUrl;
    }
  }, [date]);

  return (
    <>
      <Head>
        <title>{PAGE_TITLE}</title>
        <meta name="title" content={PAGE_TITLE} />
      </Head>
      <PageIndex />
    </>
  );
}
